import { createFileRoute } from "@tanstack/react-router";
import { ReportsScreen } from "../components/settings/reports-screen.tsx";
import { SettingsLoading } from "../components/settings/shell.tsx";
import { useSettingsFranchise } from "../components/settings/use-settings-franchise.ts";

export const Route = createFileRoute("/installningar/rapporter")({ component: Screen });

function Screen() {
  const franchise = useSettingsFranchise();
  if (franchise === null) return <SettingsLoading />;
  return <ReportsScreen franchiseId={franchise.id} />;
}
